import { Grid } from '@mui/material';
import styled from 'styled-components';

export const ContainerInputs = styled(({ ...all }) => (
  <Grid container direction="column" style={{ maxWidth: `500px` }} {...all} />
))``;
